var map = {
	"./BG.png": 2458,
	"./arrow-up.png": 9720,
	"./bg-loading.png": 6633,
	"./call-black.png": 7617,
	"./checked.png": 5088,
	"./clock.png": 5201,
	"./contact-details.png": 5490,
	"./default.png": 1836,
	"./doctor.png": 4610,
	"./get-info-head.png": 3979,
	"./global.png": 1382,
	"./info-circle.png": 3970,
	"./lobby-operating-guide.png": 9158,
	"./location-pin.old.png": 7437,
	"./location-pin.png": 36,
	"./logo copy.png": 6799,
	"./logo-family-justice.png": 9290,
	"./logo-state-court.png": 2052,
	"./logo-supreme-court.png": 9254,
	"./logo2.png": 8886,
	"./nav-bg.png": 7082,
	"./opening-hours.png": 3777,
	"./operating-hours.png": 2540,
	"./repeat.png": 5638,
	"./sg-court-logo.png": 4035,
	"./wa.png": 8383
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4504;